import React from 'react';
import ShadcnNewsletter from '@/shadcn/components/Newsletter';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Newsletter = () => {
  return /*#__PURE__*/_jsxs("form", {
    id: "newsletter",
    action: "https://excelkits.us9.list-manage.com/subscribe/post",
    method: "POST",
    className: styles.container,
    children: [/*#__PURE__*/_jsx(ShadcnNewsletter, {
      heading: "Get The Latest",
      subHeading: "Discover new Excel/Google Sheet tools & tips, along with new release updates.",
      nameInputId: "MERGE1",
      emailInputId: "MERGE0"
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "ht",
      value: "e8f2045ce2db0d9e06f5e70ce1ced50bc63de10e:MTY1NjA1NzQ2My4xNjIy"
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "u",
      value: "25c1a4edb2d54a0c7a4ce1780"
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: "id",
      value: "cc4b0a2755"
    })]
  });
};

export default Newsletter;